import { BrandingStyle, CCTM, CCTM_demo, CCTM_item, CCTM_items, CCTM_link, CCTM_nav, CCTM_route, CCTM_subnav, useCCTM, useModel, useRoute } from "@bcm-dev/bcms-vite";
import { useRef, useState } from "react";
import { SVGAsset } from "res";
import "./styles.css";

export default function BottomNavView(props) {
  const className = props.className ?? "";
  const setSrc = props.setSrc;
  let [activeClass, setActiveClass]= useState(props.src);

  const onRoute = function(component){
 
    component.setSrc = setSrc;
    component.activeClass = activeClass;
    component.setActiveClass = setActiveClass;
    return component;
  }
  const xml =  useCCTM(),
            menu = <CCTM nav-id={"bottomNav"} xml={xml} self={Parent}>
                        <CCTM_nav component={BottomNav}/>                            
                        <CCTM_route component={BottomNavItemView} postRender={onRoute}/>                  
                        <CCTM_link component={BottomNavItemView} postRender={onRoute}/> 
                        <CCTM_item component={BottomNavItemView} postRender={onRoute}/>   
                        <CCTM_items component={BottomNavItemView} postRender={onRoute}/>                     
                        <CCTM_demo component={BottomNavItemView} postRender={onRoute}/> 
                         <CCTM_subnav component={BottomNavItemView} postRender={onRoute}/>              
                    </CCTM>;
return menu;

}
export function Parent(props){
  const className = props.className ?? "";
  return   <BrandingStyle style={{ "backgroundColor": "bottom_nav_bg_mabi23" }} className={className + "bottom-nav-view"}>
       
      {props.children}
    
      </BrandingStyle>
}
export function BottomNav(props){
 const  {className} = props;
return  ( <div className="bottom-nav-container flex-container flex-horizontal align-top">
            {props.children}
          </div>);
    
   
}
export function navItem(props){


 return  (  <BottomNavItemView  {...props} />
 );
     
    
 }
export function BottomNavItemView(props) {
  const text = props.label ?? "[text]";
  const icon = props.asset_name ?props.asset_name: "";
  const route = props.to ?? "";
  const dataPointIcon = props.datapoint ? { "data-point": props.datapoint + "_Icon" } : {};
  const dataPointLabel = props.datapoint ? { "data-point": props.datapoint + "_Label" } : {};
  const className = props["custom-class"] ?? "";
  let activeClass = props.component.activeClass;
  let hasActiveClass = activeClass.indexOf(route) !== -1;
  const abi22IframeProps = props.abi22IframeProps ?? { showOnClick: false, pageID: "" };
  const ref = useRef();
  const navigate = useRoute();
  const { b, branding } = useModel();
  let {colors,options} = branding;
 let zelleColor =  options.zelle_icon_color_mabi23 !== "Unset" && options.zelle_icon_color_mabi23 !== "undefined";
 let hasZelleLogo = props.asset_name == "ZelleLogoIcon";
  let navItemColor =  colors.bottom_nav_icons_mabi23 ?"bottom_nav_icons_mabi23" :"bottomnav_active_item_mabi23";
  let navActiveItemColor =  colors.bottomnav_active_item_mabi23 ?"bottomnav_active_item_mabi23" :"bottom_nav_icons_mabi23";
  const onClick = (evt) => {
 
    if (props.target=="window" && props.to=="ch21") {
      window.postMessage({ message: "openABI22StandaloneIframe", pageID: "ch21Standalone" }, "*");
    } else {
      navigate(`/content/${ route }`);
      /**removed for now to fix custom menu issue */
      props.component.setActiveClass(route);
     props.component.setSrc(route);
    }
  }

  return (
  
    <div className={"bottom-nav-item-view flex-width "+(hasActiveClass ?"active-link":"")} ref={ref} onClick={onClick}>

      <div className={className + " bottom-nav-item-container flex-container flex-vertical align-center clickable"}>
    
      {hasZelleLogo && zelleColor? <SVGAsset className={zelleColor?"zelle_icon_"+options.zelle_icon_color_mabi23:""} id={icon} {...dataPointIcon}/>:
      <BrandingStyle style={{ "fill": hasActiveClass ? navActiveItemColor:navItemColor ,"color":hasActiveClass? navActiveItemColor:navItemColor}} className={" "+(props["asset_custom-class"]?props["asset_custom-class"]: "material-symbols-outlined md-14")}  element={<SVGAsset id={icon} {...dataPointIcon}/>} />}
       
        <BrandingStyle style={{ "color": hasActiveClass ? navActiveItemColor:navItemColor }} className="nav-item-label" element={<span {...dataPointLabel}>{text}</span>} />
     
      </div>


    </div>

  );
}
